import styled from "styled-components";

export const StyledHeader = styled.header`
    display: flex;
    height: 70px;
    padding: 30px;
    position: absolute;
    z-index: 3;
`